import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

export default function OnboardingAppTour() {
  useEffect(() => {
    if (!localStorage.getItem('tour_pending')) return;

    const tour = driver({
      showProgress: true,
      animate: true,
      overlayColor: 'rgba(0,0,0,0.7)',
      nextBtnText: 'Weiter →',
      prevBtnText: '← Zurück',
      doneBtnText: 'Fertig 🚀',
      steps: [
        {
          element: '[data-tour="job-input"]',
          popover: {
            title: 'Hier fängst du an',
            description: 'Klick hier um eine neue Stelle anzulegen — füge dann den Stellen-Link ein und die KI analysiert alles automatisch.',
            side: 'top',
          },
        },
        {
          element: '[data-tour="profil-sektion"]',
          popover: {
            title: 'Dein Profil',
            description: 'Hier siehst du dein aktives Profil. Lade deinen Lebenslauf hoch für noch bessere, personalisierte Anschreiben.',
            side: 'left',
          },
        },
      ],
      onDestroyStarted: () => {
        localStorage.removeItem('tour_pending');
        tour.destroy();
      },
    });

    const t = setTimeout(() => tour.drive(), 600);
    return () => clearTimeout(t);
  }, []);

  return null;
}
